// Generated by google-analytics.js
!function(c,u,d,l){c.GoogleAnalyticsObject=d;c[d]||(c[d]=function(){
(c[d].q=c[d].q||[]).push(arguments)});c[d].l=+new Date;l=u.createElement('script');
var e=u.scripts[0];l.src='//www.google-analytics.com/analytics.js';
e.parentNode.insertBefore(l,e)}(window,document,'ga');

module.exports = ga;